/* unplugin-vue-components disabled */import { render } from "./ModalLayout.vue?vue&type=template&id=5e808864&scoped=true&ts=true"
import script from "./ModalLayout.vue?vue&type=script&lang=ts"
export * from "./ModalLayout.vue?vue&type=script&lang=ts"

import "./ModalLayout.vue?vue&type=style&index=0&id=5e808864&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e808864"]])

export default __exports__